module.exports = __webpack_public_path__ + "assets/ee5699761e3e27b6df6e81430a98e6f5.png";